import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getHeaderVisibility } from '../../selectors/selectors.js';
import { Mobile } from '../Utils/MediaComponents/MediaComponents.tsx';
import { isRenderedInBrowser } from '../../utils/envUtils';

export class HeaderClassUpdater extends React.Component {
  componentDidMount() {
    this.setHeaderClasses();
  }

  componentDidUpdate() {
    this.setHeaderClasses();
  }

  componentWillUnmount() {
    this.setHeaderClasses();
  }

  setHeaderClasses() {
    const { visibleHeader } = this.props;

    const additionalClass = visibleHeader ? 'atlasStaticHeaderContainer__headerVisible' : '';

    const headerNode = document.getElementById('header');

    if (headerNode) {
      headerNode.className = `atlasStaticHeaderContainer ${additionalClass}`;
    }
  }

  render() {
    return (
      <Mobile>
        {(isMobile) => {
          this.isMobile = isMobile;
          if (isRenderedInBrowser()) {
            this.setHeaderClasses();
          }
          return null;
        }}
      </Mobile>
    );
  }
}

const mapStateToProps = (state) => ({
  visibleHeader: getHeaderVisibility(state),
});

HeaderClassUpdater.propTypes = {
  visibleHeader: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(HeaderClassUpdater);
